import imagesLoaded from 'imagesloaded';
import Component from '../Component';

class AspectRatio extends Component {
  constructor(options) {
    super(options);
    this.img = this.root.querySelectorAll('img');
  }

  aspectRatio() {
    this.img.forEach((image) => {
      const imgHeight = image.naturalHeight;
      const imgWidth = image.naturalWidth;
      const imgDec = imgHeight / imgWidth;

      if (imgHeight > imgWidth) {
        image.classList.add('portrait');
      }

      if (imgHeight < imgWidth) {
        image.classList.add('landscape');
      }

      if ((imgDec > 0.98 && imgDec < 1.002) || imgHeight === imgWidth) {
        image.classList.add('square');
      }
    });
  }

  attacheEventListeners() {
    imagesLoaded(this.root, () => {
      this.aspectRatio();
    });
  }

  componentDidMount() {
    this.attacheEventListeners();
  }
}

export default AspectRatio;
